import { UserRole } from '@/contexts/RoleContext';

export type ToolStatus = 'active' | 'coming_soon' | 'locked';

export interface Tool {
  id: string;
  name: string;
  description: string;
  icon: string;
  route: string;
  status: ToolStatus;
  allowedRoles: UserRole[];
  ctaLabel?: string;
  isFixed?: boolean;
  isUiOnly?: boolean;
}

export const tools: Tool[] = [
  {
    id: 'minha-forja',
    name: 'Minha Forja',
    description: 'Seu espaço pessoal para construir e gerenciar seus projetos.',
    icon: 'Hammer',
    route: '/minha-forja',
    status: 'active',
    allowedRoles: ['admin', 'student', 'partner', 'staff'],
    ctaLabel: 'Acessar Minha Forja',
    isFixed: true,
  },
  {
    id: 'marketplace',
    name: 'Marketplace',
    description: 'Marketplace completo para produtos e serviços do ecossistema Forja.',
    icon: 'ShoppingBag',
    route: '/marketplace',
    status: 'active',
    // Everyone can access Marketplace (browsing), but only sellers can create listings
    allowedRoles: ['admin', 'staff', 'partner', 'student', 'visitor'],
    ctaLabel: 'Acessar Marketplace',
  },
  {
    id: 'parceiros-forja',
    name: 'Parceiros Forja',
    description: 'Rede exclusiva de parceiros com benefícios.',
    icon: 'Handshake',
    route: '/parceiros',
    status: 'active',
    allowedRoles: ['admin', 'partner', 'staff'],
    ctaLabel: 'Acessar Parceiros',
  },
  {
    id: 'downloader',
    name: 'Downloader Forja',
    description: 'Baixe vídeos para análise de conteúdo.',
    icon: 'Download',
    route: '/downloader',
    status: 'active',
    allowedRoles: ['admin', 'student', 'partner', 'staff', 'visitor'],
    ctaLabel: 'Acessar Downloader',
  },
  {
    id: 'gmv-creators',
    name: 'GMV Criadores',
    description: 'Busque métricas de GMV de criadores do TikTok Shop.',
    icon: 'TrendingUp',
    route: '/gmv-creators',
    status: 'active',
    allowedRoles: ['admin', 'student', 'partner', 'staff', 'visitor'],
    ctaLabel: 'Acessar GMV Criadores',
  },
  {
    id: 'transcription',
    name: 'Transcrição Forja',
    description: 'Transforme vídeos em texto automaticamente.',
    icon: 'FileText',
    route: '/transcription',
    status: 'active',
    allowedRoles: ['admin', 'student', 'partner', 'staff', 'visitor'],
    ctaLabel: 'Acessar Transcrição',
  },
  {
    id: 'comunidade',
    name: 'Comunidade Forja',
    description: 'Interaja com outros membros da comunidade.',
    icon: 'Users',
    route: '/comunidade',
    status: 'active',
    allowedRoles: ['admin', 'staff', 'partner', 'student', 'visitor'],
    ctaLabel: 'Acessar Comunidade',
  },
  {
    id: 'faiscas',
    name: 'Faíscas',
    description: 'Controla a visibilidade do indicador de Faíscas na navbar e dashboard.',
    icon: 'Flame',
    route: '',
    status: 'active',
    allowedRoles: ['admin', 'student', 'partner', 'staff', 'visitor'],
    isUiOnly: true,
  },
];

export function canAccessTool(tool: Tool, role: UserRole): boolean {
  if (tool.status === 'coming_soon' || tool.status === 'locked') {
    return false;
  }
  return tool.allowedRoles.includes(role);
}

export function getToolStatus(tool: Tool, role: UserRole): ToolStatus {
  if (tool.status !== 'active') {
    return tool.status;
  }
  if (!tool.allowedRoles.includes(role)) {
    return 'locked';
  }
  return 'active';
}
